import { Component } from "react";
import { connect } from "react-redux";
import {
    setEditionState,
    selectAnalyseRisques,
    buildOpenErpCode,
} from "../../redux/analyseRisques/analyseRisquesActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import TableWithoutPagination from "../Table/TableWithoutPagination";
import "./AnalyseRisques.css";
import "../../statusIcon.css";
import AnalyseRisquesStatusIcon from "./AnalyseRisquesStatusIcon";
import AnalyseRisquesFilters from "./AnalyseRisquesFilters";
import Icon from "@mui/material/Icon/Icon";
import "./AnalyseRisquesTable.css";

class AnalyseRisquesTable extends Component {
    constructor(props) {
        super(props);

        let title = "Analyses de risques";

        if (props.moduleSpp) title = "Plans de prévention simplifiés";

        this.state = {
            searchAnalyseRisqueInput: "",
            columns: [
                {
                    Header: title,
                    columns: [
                        {
                            Header: "Statut",
                            id: "status",
                            filterable: false,
                            width: 100,
                            Cell: ({ row }) => {
                                let currentAnalyseRisques = this.props.filteredAnalysesRisques[row.index];
                                if (!currentAnalyseRisques) return null;

                                if (currentAnalyseRisques.validationInProgress)
                                    return (
                                        <div className="margin-status-icon">
                                            <Icon className="status-icon-color-red">warning</Icon>
                                        </div>
                                    );

                                return (
                                    <div className="margin-status-icon">
                                        <AnalyseRisquesStatusIcon status={currentAnalyseRisques.status} />
                                    </div>
                                );
                            },
                        },
                        {
                            Header: "Code",
                            id: "code",
                            accessor: (a) => a.id,
                            Cell: ({ row }) => {
                                let a = this.props.filteredAnalysesRisques[row.index];

                                if (!a) return null;

                                let code;

                                if (a.id) code = buildOpenErpCode(a.id);
                                else code = "/";

                                return <span className="span-center">{code}</span>;
                            },
                        },
                        {
                            Header: "Client",
                            id: "customer",
                            accessor: (a) => (a.affair ? a.affair.customer.code : ""),
                        },
                        {
                            Header: "Affaire/OT",
                            id: "affair",
                            accessor: (a) => {
                                if (a.affair) return a.affair.code;

                                if (a.affairInput) return a.affairInput;

                                if (a.numOt) return a.numOt;

                                return "";
                            },
                        },
                    ],
                },
            ],
        };
    }

    getTableTrProps(row) {
        if (row) {
            return {
                onClick: function () {
                    this.props.setEditionState(false, true);
                    this.props.selectAnalyseRisques(row.original);

                    let editUrl;

                    if (this.props.moduleSpp) editUrl = "/pps/editPps";
                    else editUrl = "/analyseRisques/editAnalyseRisques";

                    this.props.history.push(editUrl);
                }.bind(this),
                style: {
                    cursor: "pointer",
                },
            };
        } else {
            return {};
        }
    }

    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                <AnalyseRisquesFilters />
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding analyse-risques-table">
                    <TableWithoutPagination
                        filterable
                        data={this.props.filteredAnalysesRisques}
                        columns={this.state.columns}
                        getTrProps={this.getTableTrProps.bind(this)}
                        className="tableWithoutPaginationCustomClass"
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        analysesRisques: state.analysesRisques.analysesRisques,
        filteredAnalysesRisques: state.analysesRisques.filteredAnalysesRisques,
        moduleSpp: state.analysesRisques.moduleSpp,
        onlyValidationInProgressChecked: state.analysesRisques.onlyValidationInProgressChecked,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setEditionState: (creationMode, updateMode) => dispatch(setEditionState(creationMode, updateMode)),
        selectAnalyseRisques: (analyseRisques) => dispatch(selectAnalyseRisques(analyseRisques)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AnalyseRisquesTable);
